module.exports = __webpack_public_path__ + "static/media/banner.b241994b.png";